var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 26 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2315.5,-668.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Market-Icon",
    serifId: "Market Icon",
    transform: "matrix(0.833333,0,0,1,386,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2338,677L2338,677C2338.01,679.203 2339.8,680.987 2342,681L2342,684.05C2342,687.382 2339.3,690.084 2335.97,690.084C2332.89,690.084 2329.15,690.084 2326.07,690.084C2322.72,690.084 2320,687.366 2320,684.013L2320,681C2322.2,680.987 2323.99,679.203 2324,677L2324,677.53C2324,678.45 2324.37,679.333 2325.02,679.984C2325.67,680.634 2326.55,681 2327.47,681L2327.47,681C2328.41,681 2329.3,680.628 2329.97,679.967C2330.63,679.305 2331,678.408 2331,677.472L2331,677.53C2331,678.45 2331.37,679.333 2332.02,679.984C2332.67,680.634 2333.55,681 2334.47,681L2334.47,681C2335.41,681 2336.3,680.628 2336.97,679.967C2337.63,679.305 2338,678.408 2338,677.472L2338,677ZM2334,690L2328,690L2328,687.012C2328,686.224 2328.31,685.469 2328.87,684.912C2329.43,684.355 2330.18,684.042 2330.97,684.042C2330.97,684.042 2330.97,684.042 2330.97,684.042C2332.64,684.042 2334,685.398 2334,687.07C2334,688.543 2334,690 2334,690Z",
    style: {
      fill: "rgb(51,57,68)",
      stroke: "rgb(51,57,68)",
      strokeWidth: "1.09px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Roof"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.33333,-4,-223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2328,669L2328,669C2323.58,669 2320,671.238 2320,674C2320,674.526 2320,675.043 2320,675.522C2320,676.891 2321.78,678 2323.97,678C2323.97,678 2323.97,678 2323.97,678C2326.19,678 2328,676.871 2328,675.478C2328,672.816 2328,669 2328,669Z",
    style: {
      fill: "none",
      stroke: "rgb(51,57,68)",
      strokeWidth: "0.9px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.33333,4666,-223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2328,669L2328,669C2323.58,669 2320,671.238 2320,674C2320,674.526 2320,675.043 2320,675.522C2320,676.891 2321.78,678 2323.97,678C2323.97,678 2323.97,678 2323.97,678C2326.19,678 2328,676.871 2328,675.478C2328,672.816 2328,669 2328,669Z",
    style: {
      fill: "none",
      stroke: "rgb(51,57,68)",
      strokeWidth: "0.9px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.875,0,0,1.33333,294,-223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2328,669L2320,669L2320,675.836C2320,677.031 2321.77,678 2323.96,678C2323.96,678 2323.96,678 2323.96,678C2326.19,678 2328,677.011 2328,675.791C2328,673.126 2328,669 2328,669Z",
    style: {
      fill: "none",
      stroke: "rgb(51,57,68)",
      strokeWidth: "0.93px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.875,0,0,1.33333,301,-223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2328,669L2320,669L2320,675.836C2320,677.031 2321.77,678 2323.96,678C2323.96,678 2323.96,678 2323.96,678C2326.19,678 2328,677.011 2328,675.791C2328,673.126 2328,669 2328,669Z",
    style: {
      fill: "none",
      stroke: "rgb(51,57,68)",
      strokeWidth: "0.93px"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketIcon);
export default __webpack_public_path__ + "static/media/market_icon.ccd4cc12609d17d9acd0935a2ae07492.svg";
export { ForwardRef as ReactComponent };